import Crud from "../components/NonconformityType/Crud.vue";
import Add from "../components/NonconformityType/Add.vue";
import Edit from "../components/NonconformityType/Edit.vue";

let routes = {
    path: "/nonconformity-types",
    component: resolve => require(["../components/layout/App"], resolve),
    children: [
        {
            path: "/nonconformity-types",
            name: "Tipos de Não Conformidades",
            component: Crud
        },
        {
            path: "/nonconformity-types/add",
            name: "Novo Tipo de Não Conformidade",
            component: Add
        },
        {
            path: "/nonconformity-types/edit/:id",
            name: "Editar Tipo de Não Conformidade",
            component: Edit
        }
    ]
};

export default routes;



// WEBPACK FOOTER //
// ./src/router/nonconformitytype.js